document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header');
  if (!header) return;

  const logo = header.querySelector('.header__logo');
  const nav = header.querySelector('.header__navigation');
  const icons = header.querySelector('.header__icons--right');
  const search = header.querySelector('.search-drawer-button');
  if (!logo || !nav || !icons || !search) return;

  const topRow = document.createElement('div');
  topRow.classList.add('header-top-row');

  const topColLeft = document.createElement('div');
  topColLeft.classList.add('header-top-col', 'search-col');

  const topColCenter = document.createElement('div');
  topColCenter.classList.add('header-top-col', 'logo-col');
  topColCenter.appendChild(logo);

  const topColRight = document.createElement('div');
  topColRight.classList.add('header-top-col', 'icons-col');
  const iconsButtons = icons.querySelector('.header__buttons');
  if (iconsButtons) iconsButtons.insertBefore(search, iconsButtons.firstChild);
  topColRight.appendChild(icons);

  topRow.appendChild(topColLeft);
  topRow.appendChild(topColCenter);
  topRow.appendChild(topColRight);

  const bottomRow = document.createElement('div');
  bottomRow.classList.add('header-bottom-row');
  bottomRow.appendChild(nav);

  header.replaceChildren(topRow, bottomRow);
});
